import React, { Suspense, lazy } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
// Constants
import {
  ABOUT_PAGE_URL,
  ADMIN_PAGE_URL,
  BLOG_PAGE_URL,
  CLIPS_FANSITES_PAGE_URL,
  DOMINATION_PAGE_URL,
  FULL_BUSINESS_URL,
  GALLERY_PAGE_URL,
  HOME_PAGE_URL,
  LINKS_PAGE_URL,
  MAINTENANCE_PAGE_URL,
  POLICIES_PAGE_URL,
  SPLOSHING_PAGE_URL,
  WRESTLING_PAGE_URL,
} from './utils/Constants';
// Components
import LoadingScreen from './components/utils/LoadingScreen';
// Utils
import { AuthenticateAdmin } from './utils/user/AuthenticateUser';
// Normal import for HomePage (no lazy loading)
import HomePage from './pages/home/HomePage';
import LinksPage from './pages/links/LinksPage';
import AboutPage from './pages/about/AboutPage';
import DominationPage from './pages/domination/DominationPage';
import WrestlingPage from './pages/westling/WrestlingPage';
import SploshingPage from './pages/sploshing/SploshingPage';
import GalleryPage from './pages/gallery/GalleryPage';
import BlogPage from './pages/blog/BlogPage';
import ClipsPage from './pages/clips/ClipsPage';
import BlogPostPage from './pages/blog/BlogPostPage';
// Lazy-loaded Pages
const AdminPage = lazy(() => import('./pages/admin/AdminPage'));
const MaintenancePage = lazy(() =>
  import('./pages/maintenance/MaintenancePage')
);
const Error404 = lazy(() => import('./pages/error/Error404'));
const TermAndPoliciesPage = lazy(() =>
  import('./pages/policies/TermAndPoliciesPage')
);

function App() {
  const { pathname } = useLocation();
  // Every page is its own canonical; strip trailing slashes so /about/ and /about match
  const canonicalPath = pathname === '/' ? '/' : pathname.replace(/\/+$/, '');

  return (
    <>
      <Helmet>
        <link rel='canonical' href={`${FULL_BUSINESS_URL}${canonicalPath}`} />
      </Helmet>

      {/* Suspense component wraps the lazy-loaded components */}
      <Suspense fallback={<LoadingScreen />}>
        <Routes>
          {/* Main page routes */}
          <Route path={HOME_PAGE_URL} index element={<HomePage />} />
          <Route path={ABOUT_PAGE_URL} element={<AboutPage />} />
          <Route path={DOMINATION_PAGE_URL} element={<DominationPage />} />
          <Route path={WRESTLING_PAGE_URL} element={<WrestlingPage />} />
          <Route path={SPLOSHING_PAGE_URL} element={<SploshingPage />} />
          <Route path={CLIPS_FANSITES_PAGE_URL} element={<ClipsPage />} />
          <Route path={GALLERY_PAGE_URL} element={<GalleryPage />} />
          <Route path={BLOG_PAGE_URL} element={<BlogPage />} />
          <Route path={`${BLOG_PAGE_URL}/:slug`} element={<BlogPostPage />} />

          {/* Eager loaded */}
          <Route path={LINKS_PAGE_URL} element={<LinksPage />} />
          <Route path={POLICIES_PAGE_URL} element={<TermAndPoliciesPage />} />

          {/* Other */}
          <Route path={MAINTENANCE_PAGE_URL} element={<MaintenancePage />} />
          {/* Secured routes */}
          <Route
            path={ADMIN_PAGE_URL}
            element={
              <AuthenticateAdmin>
                <AdminPage />
              </AuthenticateAdmin>
            }
          />
          {/* Error routes */}
          <Route path='*' element={<Error404 />} />
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
